import Dinero from 'dinero.js'

Dinero.defaultCurrency = 'ARS'

export default function moneyFormat(amount) {
  const montoEnCentavos = amount * 100
  const format = Number.isInteger(amount) ? '$0,0' : '$0,0.00'

  return Dinero({ amount: parseInt(montoEnCentavos, 10) })
    .setLocale('es-AR')
    .toFormat(format)
}

export { moneyFormat }

export const toLocaleCurrency = (data) => data?.toLocaleString('es-AR')
